import { Policy } from 'policy-lib';
import { getGate } from '../../utils/getGates';
import { scopes } from '../../constants/scopes';
import { isContact } from '../utils';
import { getScope } from '../../utils/getScopes';
export class EnrichmentPolicy extends Policy {
  accessBilling() {
    return this.user.hasScope(scopes.BILLING_ACCESS);
  }
  accessContinuousEnrichment() {
    return this.user.hasScope(scopes.ENRICHMENT_CONTINUOUS_ACCESS);
  }

  /**
   * Is a user-level role-based permission that allows a user to access
   * enrichment features.
   *
   * @returns {boolean}
   */
  accessEnrichment() {
    return this.user.hasScope(scopes.DATA_ENRICHMENT_ACCESS);
  }
  accessManualEnrichment(enrichmentType) {
    if (!this.accessEnrichment()) {
      return false;
    }
    if (isContact(enrichmentType)) {
      return this.record.settings.contactEnrichmentManual;
    } else if (enrichmentType === 'company') {
      return this.record.settings.companyEnrichmentManual;
    }
    return false;
  }

  /**
   * Returns whether a user can access the enrichment platform pages and
   * features. This is parcel dependent and indicates whether the portal
   * has a breeze credits parcel.
   *
   * @returns {boolean}
   */
  accessPlatform() {
    return this.user.hasScope(scopes.ENRICHMENT_PLATFORM_ACCESS);
  }
  accessSmartProperties() {
    return this.user.hasGate(getGate('enrichmentSmartProperties'));
  }
  accessEnrichAssociationsLists() {
    return this.user.hasGate(getGate('enrichmentAssociationsLists'));
  }
  changeSettings() {
    return this.user.hasScope(getScope('manageDataEnrichment'));
  }
  free() {
    return this.user.hasScope(scopes.BREEZE_INTELLIGENCE_FREE);
  }
  get isLoaded() {
    return this.record.isLoaded;
  }
  enrichmentSettingAuto() {
    return this.record.settings.companyEnrichmentAuto && this.record.settings.contactEnrichmentAuto;
  }

  /**
   * Returns whether a user can upgrade their account which requires
   * billing access.
   *
   * @returns {boolean}
   */
  upgrade() {
    return this.accessBilling();
  }
  viewUpgradeCTA() {
    return !this.accessContinuousEnrichment() && this.accessBilling();
  }
  viewAddonCTA() {
    return !this.accessEnrichment() && this.accessBilling();
  }
  viewAutoSettingsNudge() {
    return this.changeSettings() && !this.enrichmentSettingAuto();
  }
  viewCredits() {
    return this.accessEnrichment();
  }
  viewEnrichmentActions() {
    return this.accessPlatform() || this.free();
  }
}